import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';
import WebhookEventRow from './webhook_event_row';

export class WebhookEventsTable extends React.Component {
  static propTypes = {
    webhookEvents: PropTypes.array.isRequired
  };

  render() {
    return (
      <SelectableRecordTable columnHeaders={this.renderColunnHeaders()} hasSelectColumn={false}>
        {this.renderWebhookEvents()}
      </SelectableRecordTable>
    );
  }

  renderColunnHeaders() {
    return (
      <React.Fragment>
        <th>ID</th>
        <th>Identifier</th>
        <th>Status</th>
        <th>Event Type</th>
        <th>Received At</th>
        <th></th>
      </React.Fragment>
    );
  }

  renderWebhookEvents() {
    return this.props.webhookEvents.map(webhookEvent => (
      <WebhookEventRow key={webhookEvent.id} webhookEvent={webhookEvent} />
    ));
  }
}

const mapStateToProps = state => ({
  webhookEvents: state.search.webhookEvents
});

export default connect(mapStateToProps)(WebhookEventsTable);
